import { useEffect, useState } from 'react';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import RelatoriosService from '../../services/RelatoriosService';
import { IAgrupadoPorConta, IRelatorio } from '../../interfaces/IRelatorio';
import { IEmpresas } from '../../interfaces/IEmpresas';
import { Formatter, Tipo } from './Relatorio';
import Checkbox from '@material-ui/core/Checkbox';

interface ILinhaCabecalho {
  id: string,
  nome: string
}

const nomesCabecalho: ILinhaCabecalho[] = [
  { id: '0', nome: 'Conta Ref.' },
  { id: '1', nome: 'Descrição Referencial' },
  { id: '2', nome: 'Conta Empresa' },
  { id: '3', nome: 'Descrição Empresa' },
  { id: '4', nome: 'Saldo Inicial' },
  { id: '5', nome: 'Lançamento' },
  { id: '6', nome: 'Movimentação Débito' },
  { id: '7', nome: 'Movimentação Crédito' },
  { id: '8', nome: 'Saldo Final' },
  { id: '9', nome: 'Lançamento' },
  { id: '10', nome: 'Algoritmo de Constância' }
];

function Row({ styles, empresa, dataInicial, dataFinal, relatorio, trocarValor, funcaoSelecionado }: { styles: any, empresa: IEmpresas | undefined, dataInicial: Date | undefined, dataFinal: Date | undefined, relatorio: IRelatorio, trocarValor: (contaEmpresa: string, marcado: boolean) => void, funcaoSelecionado: (contaEmpresa: string) => boolean }) {
  const [open, setOpen] = useState<boolean>(false);
  const [agrupadoPorConta, setAgrupadoPorConta] = useState<IAgrupadoPorConta>({} as IAgrupadoPorConta);
  const history = useHistory();

  async function funcaoClicar() {
    setOpen(!open);

    if (!open && empresa?.id && dataInicial && dataFinal) {
      localStorage.setItem(`${Tipo.AbaSelecionada}`, "2");
      await RelatoriosService.agrupadoPorConta(empresa.id, dataInicial, dataFinal, relatorio.contaEmpresa, x => setAgrupadoPorConta(x));
    }
  }

  return <>
    <TableRow style={{ outline: '1px solid #A3A3A3', backgroundColor: relatorio.possuiAvisosOuErros ? 'rgba(241, 196, 15, 0.2)' : 'unset' }} >
      <TableCell className={styles.cell} align='center'>
        <IconButton aria-label="expand row" size="small" onClick={funcaoClicar}>
          {
            open ?
              <i className="bi bi-arrow-up" style={{ color: '#525252' }} />
              :
              <i className="bi bi-arrow-down" style={{ color: '#525252' }} />
          }
        </IconButton>
        {relatorio.contaReferencial}
      </TableCell>
      <TableCell className={styles.cell} align='left'>{relatorio.descricaoReferencial}</TableCell>
      <TableCell className={styles.cell} align='center'>{relatorio.contaEmpresa}</TableCell>
      <TableCell className={styles.cell} align='left'>{relatorio.descricaoEmpresa}</TableCell>
      <TableCell className={styles.cell} align='center'>{Formatter.format(relatorio.saldoInicial)}</TableCell>
      <TableCell className={styles.cell} align='center'>{relatorio.lancamento}</TableCell>
      <TableCell className={styles.cell} align='left' style={{ paddingLeft: '25px' }}>{Formatter.format(relatorio.debito)}</TableCell>
      <TableCell className={styles.cell} align='left'>{Formatter.format(relatorio.credito)}</TableCell>
      <TableCell className={styles.cell} align='center'>{Formatter.format(relatorio.saldo)}</TableCell>
      <TableCell className={styles.cell} align='center'>{relatorio.lancamento}</TableCell>
      <TableCell className={styles.cell} align='center'>{relatorio.algoritimoConstancia}</TableCell>
      <TableCell className={styles.cell} align='center'>
        <Checkbox onChange={e => trocarValor(relatorio.contaEmpresa, e.target.checked)} checked={funcaoSelecionado(relatorio.contaEmpresa)} />
      </TableCell>
      {relatorio.possuiAvisosOuErros && (
        <TableCell className={styles.cell} align='center'>
          <i className="bi bi-info-circle" style={{ color: '#525252' }} />
        </TableCell>
      )}
    </TableRow>
    <TableRow style={{ transform: 'translate(10px, 0)' }} >
      <TableCell style={{ border: 'none', padding: '0' }} colSpan={11}>
        <Collapse in={open} style={{ backgroundColor: '#EFF0F5', margin: '0.5px 0 1px 0', width: 'calc(100% - 20px)' }} >
          <Table>
            <TableHead>
              {
                <TableRow style={{ outline: '1px solid #A3A3A3', border: 'none' }}>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Erro}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Erro}`); }} className="fas fa-exclamation-circle" style={{ padding: '3px 5px 0 0', color: '#EB1F44', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Erro}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Erro}`); }} style={{ cursor: 'pointer' }}>Erros: {agrupadoPorConta.erros}</label>
                    </div>
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Aviso}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Aviso}`); }} className="fas fa-exclamation-triangle" style={{ padding: '3px 5px 0 0', color: '#FFB629', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Aviso}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Aviso}`); }} style={{ cursor: 'pointer' }}>Avisos: {agrupadoPorConta.avisos}</label>
                    </div>
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Recomendacao}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Recomendacao}`); }} className="fas fa-exclamation-circle" style={{ padding: '3px 5px 0 0', color: '#0FC1C1', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Recomendacao}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Recomendacao}`); }} style={{ cursor: 'pointer' }}>Recomendações: {agrupadoPorConta.recomendacoes}</label>
                    </div>
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Match}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Match}`); }} className="fas fa-compress-alt" style={{ padding: '3px 5px 0 0', color: '#00B757', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Match}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Match}`); }} style={{ cursor: 'pointer' }}>Match de Conciliaçõe: {agrupadoPorConta.matchesConciliacao}</label>
                    </div>
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Pendente}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Pendente}`); }} className="fas fa-external-link-alt" style={{ padding: '3px 5px 0 0', color: '#FF9029', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Pendente}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Pendente}`); }} style={{ cursor: 'pointer' }}>Pendentes de Conciliações: {agrupadoPorConta.pendentesConciliacao}</label>
                    </div>
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Conciliado}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Conciliado}`); }} className="fas fa-compress-arrows-alt" style={{ padding: '3px 5px 0 0', color: '#FF9029', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Conciliado}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Conciliado}`); }} style={{ cursor: 'pointer' }}>Conciliados: {agrupadoPorConta.conciliados}</label>
                    </div>
                  </TableCell>
                </TableRow>
              }
            </TableHead>
          </Table>
        </Collapse>
      </TableCell>
    </TableRow>
  </>
}

function RelatorioRelatorio({ empresa, dataInicial, dataFinal, setDadosExportar }: { empresa: IEmpresas | undefined, dataInicial: Date | undefined, dataFinal: Date | undefined, setDadosExportar: any }) {

  const [carregado, setCarregado] = useState<boolean>(false);
  const [dadosResumidos, setDadosResumidos] = useState<IRelatorio[]>([]);
  const [selecionados, setSelecionados] = useState<string[]>([]);
  const [todosMarcados, setTodosMarcados] = useState<boolean>(false);
  const useStyles = makeStyles({
    cell: {
      padding: '4px'
    }
  });
  const styles = useStyles();

  useEffect(() => {
    async function preCarregar() {
      setCarregado(false);
      if (empresa?.id && dataInicial && dataFinal && new Date(dataInicial).toISOString().split('-')[0] === new Date(dataFinal).toISOString().split('-')[0]) {
        await RelatoriosService.dadosResumidos(empresa.id, dataInicial, dataFinal, x => {
          setDadosResumidos(x);
          setDadosExportar(x.map(d => ({
            'Conta Referencial': d.contaReferencial,
            'Descrição Referencial': d.descricaoReferencial,
            'Conta Empresa': d.contaEmpresa,
            'Descrição Empresa': d.descricaoEmpresa,
            'Saldo Inicial': d.saldoInicial,
            'Lançamento': d.lancamento,
            'Débito': d.debito,
            'Crédito': d.credito,
            'Saldo': d.saldo
          })));
        })
        setCarregado(true);
      }
    }

    setTimeout(() => {
      preCarregar()
    }, 1000)

  }, [empresa, dataInicial, dataFinal, setDadosExportar])

  useEffect(() => {
    setTodosMarcados(dadosResumidos.length > 0 && selecionados.length === new Set(dadosResumidos.map(x => x.contaEmpresa)).size);
    localStorage.setItem(`${Tipo.ListaContasEmpresa}`, JSON.stringify(selecionados));

    //eslint-disable-next-line
  }, [selecionados]);

  async function trocarTodosValores(valor: boolean) {
    if (valor) {
      const listaContasEmpresa = dadosResumidos.map(x => x.contaEmpresa);

      setSelecionados(listaContasEmpresa);
    }
    else {
      setSelecionados([]);
    }
  }

  async function trocarValor(contaEmpresa: string, valor: boolean) {
    if (valor) {
      setSelecionados([...selecionados, contaEmpresa]);
    }
    else {
      setSelecionados(selecionados.filter(x => x !== contaEmpresa));
    }
  }

  return <>
    {

      dataInicial && dataFinal ?
        new Date(dataInicial).toISOString().split('-')[0] === new Date(dataFinal).toISOString().split('-')[0] ?
          carregado ?
            dadosResumidos.length > 0 ?
              <Table aria-label="collapsible table" style={{ userSelect: 'none', marginBottom: '200px' }}>
                <TableHead>
                  <TableRow hover role="checkbox" style={{ border: 'none', outline: '1px solid #A3A3A3' }} >
                    {
                      nomesCabecalho.map((x, index) => <TableCell key={index} className={styles.cell} align={index === 0 ? 'center' : 'left'} style={{ fontWeight: 600, color: '#5E6397' }}>{x.nome}</TableCell>)
                    }
                    <TableCell padding="checkbox" className={styles.cell} align='center'>
                      <Checkbox onChange={e => trocarTodosValores(e.target.checked)} checked={todosMarcados} />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    dadosResumidos.map((x, index) => <Row key={index} styles={styles} empresa={empresa} dataInicial={dataInicial} dataFinal={dataFinal} relatorio={x} trocarValor={trocarValor} funcaoSelecionado={(contaEmpresa: string) => selecionados.find(x => x === contaEmpresa) !== undefined} />)
                  }
                </TableBody>
              </Table>
              : <h2 className="mt-5">Não há dados para serem exibidos</h2>
            : <p className="mt-5">Carregando...</p>
          : <h2 className="mt-5">As datas de início e fim devem estar contidas dentro do mesmo ano.</h2>
        : <h2 className="mt-5">Preencha o campo Período e clique em buscar para carregar os dados</h2>
    }
  </>
}

export default RelatorioRelatorio;